import { createMigration } from './utils';

const brokenAssetRenderUrl = 'https://storage.googleapis.com/lumen5-user-fbac5e02-4735-49a2-b92a-f3c4d140b6a1/render-aDMO-TalkingHeadPlaceholder2mp4-2Ggkx7bM20y-new.mp4';

export const migrationTo9_169 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },

    migrateScene(scene) {
        return scene.withMutations(map => {
            map.get('children', []).forEach((asset, c) => {
                if (asset.get('classType') === 'TimeAwareMediaAsset' && asset.getIn(['sourceData', 'render_url']) === brokenAssetRenderUrl) {
                    map.setIn(['children', c, 'sourceData', 'has_audio'], false);
                }
            });

            map.get('subslides', []).forEach((subslide, s) => {
                subslide.get('children', []).forEach((asset, c) => {
                    if (asset.get('classType') === 'TimeAwareMediaAsset' && asset.getIn(['sourceData', 'render_url']) === brokenAssetRenderUrl) {
                        map.setIn([['subslides', s, 'children', c], 'sourceData', 'has_audio'], false);
                    }
                });
            });
        });
    },
});
